module.exports = __webpack_public_path__ + "static/media/Vector2.03e94839.svg";